"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerSyntheticSelectionBehaviours = exports.registerWidgetRegistryBehaviours = exports.registerAccordionBehaviours = exports.registerROICalculatorBehaviours = exports.registerButtonBehaviours = exports.registerSideBySideBehaviours = exports.registerCommentBehaviours = exports.registerVariableBehaviours = exports.registerContentLoopBehaviours = exports.registerTableNavigationBehaviours = exports.registerTableBehaviours = exports.registerWidgetBehaviours = exports.registerLinkBehaviours = exports.registerImageBehaviours = exports.registerPasteBehaviours = exports.registerToolbarBehaviours = exports.registerSelectionBehaviours = exports.registerCopyBehaviours = exports.registerClickToAddBehaviours = exports.registerCommonBehaviours = exports.registerHorizontalRuleBehaviours = exports.registerShortcutBehaviours = exports.registerHeadingBehaviours = exports.registerListBehaviours = exports.registerCursorValidationBehaviours = void 0;
var ButtonBehaviours_1 = __importDefault(require("./ButtonBehaviours"));
var CommentBehaviours_1 = __importDefault(require("./CommentBehaviours"));
var CommonBehaviours_1 = __importDefault(require("./CommonBehaviours"));
var CopyBehaviours_1 = __importDefault(require("./CopyBehaviours"));
var ClickBehaviours_1 = __importDefault(require("./ClickBehaviours"));
var CursorValidationBehaviours_1 = __importDefault(require("./CursorValidationBehaviours"));
var HeadingBehaviours_1 = __importDefault(require("./HeadingBehaviours"));
var HorizontalRuleBehaviours_1 = __importDefault(require("./HorizontalRuleBehaviours"));
var ImageBehaviours_1 = __importDefault(require("./ImageBehaviours"));
var LinkBehaviours_1 = __importDefault(require("./LinkBehaviours"));
var ListItemBehaviours_1 = __importDefault(require("./ListItemBehaviours"));
var PasteBehaviours_1 = __importDefault(require("./PasteBehaviours"));
var ShortcutBehaviours_1 = __importDefault(require("./ShortcutBehaviours"));
var TableBehaviours_1 = __importDefault(require("./TableBehaviours"));
var TableNavigationBehaviours_1 = __importDefault(require("./TableNavigationBehaviours"));
var ToolbarBehaviours_1 = __importDefault(require("./ToolbarBehaviours"));
var VariableBehaviours_1 = __importDefault(require("./VariableBehaviours"));
var WidgetBehaviours_1 = __importDefault(require("./WidgetBehaviours"));
var ROICalculatorBehaviours_1 = __importDefault(require("./ROICalculator/ROICalculatorBehaviours"));
var WidgetRegistryBehaviours_1 = __importDefault(require("./WidgetRegistryBehaviours"));
var ContentLoop_1 = require("./ContentLoop");
var SideBySideBehaviours_1 = require("./SideBySide/SideBySideBehaviours");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ClickToAddBehaviours_1 = require("./ClickToAdd/ClickToAddBehaviours");
var AccordionBehaviours_1 = require("./Accordion/AccordionBehaviours");
var SyntheticSelectionBehaviours_1 = __importDefault(require("./SyntheticSelectionBehaviours"));
var registerCursorValidationBehaviours = function (di, router) {
    var cursorValidationBehaviours = di.invoke(CursorValidationBehaviours_1.default);
    router.register(cursorValidationBehaviours.recordKeyPress);
};
exports.registerCursorValidationBehaviours = registerCursorValidationBehaviours;
var registerListBehaviours = function (di, router) {
    var listBehaviours = di.invoke(ListItemBehaviours_1.default);
    router.register(listBehaviours.onEnterEmpty);
    router.register(listBehaviours.onTab);
    router.register(listBehaviours.onBackspace);
    router.register(listBehaviours.onShiftTab);
    router.register(listBehaviours.onListShortcutDash);
    router.register(listBehaviours.onListShortcutStar);
    router.register(listBehaviours.onListShortcutNumber);
};
exports.registerListBehaviours = registerListBehaviours;
var registerHeadingBehaviours = function (di, router) {
    var headingBehaviours = di.invoke(HeadingBehaviours_1.default);
    router.register(headingBehaviours.onHeading1ShortcutHash);
    router.register(headingBehaviours.onHeading2ShortcutHash);
};
exports.registerHeadingBehaviours = registerHeadingBehaviours;
var registerShortcutBehaviours = function (di, router) {
    var shortcutBehaviours = di.invoke(ShortcutBehaviours_1.default);
    router.register(shortcutBehaviours.arrow);
    router.register(shortcutBehaviours.makeLink);
    router.register(shortcutBehaviours.ctrl_b);
    router.register(shortcutBehaviours.ctrl_i);
    router.register(shortcutBehaviours.blockquote);
    if (di.get("usingFeature")(FeatureFlag_1.default.Emoji)) {
        router.register(shortcutBehaviours.smiley);
        router.register(shortcutBehaviours.frown);
        router.register(shortcutBehaviours.tongue);
        router.register(shortcutBehaviours.grin);
        router.register(shortcutBehaviours.gasp);
        router.register(shortcutBehaviours.wink);
        router.register(shortcutBehaviours.confused);
        router.register(shortcutBehaviours.glasses);
        router.register(shortcutBehaviours.sunglasses);
        router.register(shortcutBehaviours.heart);
        router.register(shortcutBehaviours.poop);
        router.register(shortcutBehaviours.joy);
        router.register(shortcutBehaviours.fire);
        router.register(shortcutBehaviours.thumbsUp);
        router.register(shortcutBehaviours.thumbsDown);
        router.register(shortcutBehaviours.rocket);
        router.register(shortcutBehaviours.hundred);
        router.register(shortcutBehaviours.raisedHands);
        router.register(shortcutBehaviours.pray);
        router.register(shortcutBehaviours.flex);
        router.register(shortcutBehaviours.clap);
        router.register(shortcutBehaviours.ok);
        router.register(shortcutBehaviours.tada);
        router.register(shortcutBehaviours.wave);
        router.register(shortcutBehaviours.sparkles);
        router.register(shortcutBehaviours.shrug);
    }
};
exports.registerShortcutBehaviours = registerShortcutBehaviours;
var registerHorizontalRuleBehaviours = function (di, router) {
    var horizontalRuleBehaviours = di.invoke(HorizontalRuleBehaviours_1.default);
    router.register(horizontalRuleBehaviours.addHorizontalRule);
};
exports.registerHorizontalRuleBehaviours = registerHorizontalRuleBehaviours;
var registerCommonBehaviours = function (di, router) {
    var commonBehaviours = di.invoke(CommonBehaviours_1.default);
    router.register(commonBehaviours.onShiftEnter);
    router.register(commonBehaviours.onEnter);
    router.register(commonBehaviours.onBackspaceEmptySingleton);
};
exports.registerCommonBehaviours = registerCommonBehaviours;
var registerClickToAddBehaviours = function (di, router) {
    var clickToAddBehaviours = di.invoke(ClickToAddBehaviours_1.getClickToAddBehaviours);
    router.register(clickToAddBehaviours.onClickToAddImage);
};
exports.registerClickToAddBehaviours = registerClickToAddBehaviours;
var registerCopyBehaviours = function (di, router) {
    var copyBehaviours = di.invoke(CopyBehaviours_1.default);
    router.register(copyBehaviours.copyFromTable);
    router.register(copyBehaviours.cutFromTable);
    router.register(copyBehaviours.dragFromTable);
    router.register(copyBehaviours.copyTable);
    router.register(copyBehaviours.cutTable);
    router.register(copyBehaviours.dragText);
    router.register(copyBehaviours.copyCatchAll);
    router.register(copyBehaviours.cutCatchAll);
};
exports.registerCopyBehaviours = registerCopyBehaviours;
var registerSelectionBehaviours = function (di, router) {
    var clickBehaviours = di.invoke(ClickBehaviours_1.default);
    router.register(clickBehaviours.tripleClick);
};
exports.registerSelectionBehaviours = registerSelectionBehaviours;
var registerToolbarBehaviours = function (di, router) {
    var toolbarBehaviours = di.invoke(ToolbarBehaviours_1.default);
    router.register(toolbarBehaviours.onReselection);
    router.register(toolbarBehaviours.onButtonBold);
    router.register(toolbarBehaviours.onButtonItalic);
    router.register(toolbarBehaviours.onButtonStrikeThrough);
    router.register(toolbarBehaviours.onButtonBulletListToggle);
    router.register(toolbarBehaviours.onButtonNumberedListToggle);
    router.register(toolbarBehaviours.onButtonHeading2Toggle);
    router.register(toolbarBehaviours.onButtonBlockQuoteToggle);
    router.register(toolbarBehaviours.onButtonHeading1Toggle);
    router.register(toolbarBehaviours.onButtonLinkToggle);
    router.register(toolbarBehaviours.onButtonCommentAdd);
};
exports.registerToolbarBehaviours = registerToolbarBehaviours;
var registerPasteBehaviours = function (di, router) {
    var pasteBehaviours = di.invoke(PasteBehaviours_1.default);
    var usingFeature = di.get("usingFeature");
    if (usingFeature(FeatureFlag_1.default.PastingURLLinks)) {
        router.register(pasteBehaviours.pasteURLOverText);
        router.register(pasteBehaviours.pasteURL);
    }
    router.register(pasteBehaviours.pasteVariableTelemetry);
    router.register(pasteBehaviours.pasteLeadingTableIntoTableCell);
    router.register(pasteBehaviours.pasteLeadingTableIntoSelectedTable);
    router.register(pasteBehaviours.pasteIntoTableCellMiddleware);
    router.register(pasteBehaviours.pasteIntoSelectedTableMiddleware);
    router.register(pasteBehaviours.pasteTextOverTableCells);
    router.register(pasteBehaviours.pasteLeadingImage);
    router.register(pasteBehaviours.pasteLeadingTable);
    router.register(pasteBehaviours.pasteLeadingSideBySide);
    router.register(pasteBehaviours.pasteLeadingAccordion);
    router.register(pasteBehaviours.pasteLeadingListItemIntoPlaceholder);
    router.register(pasteBehaviours.pasteIntoH1Placeholder);
    router.register(pasteBehaviours.pasteIntoH2Placeholder);
    router.register(pasteBehaviours.pasteIntoUnformattedPlaceholder);
    router.register(pasteBehaviours.pasteLeadingListItem);
    router.register(pasteBehaviours.pasteCatchAll);
};
exports.registerPasteBehaviours = registerPasteBehaviours;
var registerImageBehaviours = function (di, router) {
    var imageBehaviours = di.invoke(ImageBehaviours_1.default);
    var usingFeature = di.get("usingFeature");
    router.register(imageBehaviours.onLeftKeyInEmptyImage);
    router.register(imageBehaviours.onUpKeyInEmptyImage);
    router.register(imageBehaviours.onRightKeyInEmptyImage);
    router.register(imageBehaviours.onDownKeyInEmptyImage);
    router.register(imageBehaviours.onEnter);
    router.register(imageBehaviours.onDragImageWidget);
    router.register(imageBehaviours.onDropImageWidget);
    router.register(imageBehaviours.onDragEndImageWidget);
    if (usingFeature(FeatureFlag_1.default.SidebarImages)) {
        router.register(imageBehaviours.onDragOverHoldingImage);
    }
    router.register(imageBehaviours.onDropImageFromSidebar);
};
exports.registerImageBehaviours = registerImageBehaviours;
var registerLinkBehaviours = function (di, router) {
    var linkBehaviours = di.invoke(LinkBehaviours_1.default);
    router.register(linkBehaviours.onLinkUpdate);
    router.register(linkBehaviours.onLinkRemove);
};
exports.registerLinkBehaviours = registerLinkBehaviours;
var registerWidgetBehaviours = function (di, router) {
    var widgetBehaviours = di.invoke(WidgetBehaviours_1.default, {}, { router: router });
    router.register(widgetBehaviours.onImageUpdate);
    router.register(widgetBehaviours.onDropTokenOnImage);
    router.register(widgetBehaviours.onDropTokenOnVideo);
    router.register(widgetBehaviours.onDropTokenOnGoogleMaps);
    router.register(widgetBehaviours.onDropTokenOnIframe);
    router.register(widgetBehaviours.onDropImageOnEmptyImage);
    router.register(widgetBehaviours.onImageChoose);
    router.register(widgetBehaviours.onAddImage);
    router.register(widgetBehaviours.onVideoUpdate);
    router.register(widgetBehaviours.onTogglePlus);
    router.register(widgetBehaviours.onKeyboardPlus);
    router.register(widgetBehaviours.onWidgetAdderEnter);
    router.register(widgetBehaviours.onWidgetAdderUpKey);
    router.register(widgetBehaviours.onWidgetAdderDownKey);
    router.register(widgetBehaviours.onWidgetAdderEsc);
    router.register(widgetBehaviours.onClickWidgetAdderItem);
    router.register(widgetBehaviours.onGoogleMapsUpdate);
    router.register(widgetBehaviours.onIframeUpdate);
    router.register(widgetBehaviours.onDropImage);
    router.register(widgetBehaviours.onBackspaceInEmptyAfterWidget);
    router.register(widgetBehaviours.onBackspaceAfterWidget);
    router.register(widgetBehaviours.onDeleteBeforeWidget);
};
exports.registerWidgetBehaviours = registerWidgetBehaviours;
var registerTableBehaviours = function (di, router) {
    var tableBehaviours = di.invoke(TableBehaviours_1.default);
    router.register(tableBehaviours.onTableAdd);
    router.register(tableBehaviours.onTableDelete);
    router.register(tableBehaviours.onTableAddRow);
    router.register(tableBehaviours.onTableAddRepeatingRow);
    router.register(tableBehaviours.onTableSetRepeatingRowToken);
    router.register(tableBehaviours.onTableDeleteRows);
    router.register(tableBehaviours.onTableAddColumn);
    router.register(tableBehaviours.onTableDeleteColumns);
    router.register(tableBehaviours.onTableResizeColumns);
    router.register(tableBehaviours.onTableSelectionChange);
    router.register(tableBehaviours.updateAnyTableSelection);
    router.register(tableBehaviours.onTableCtrlB);
    router.register(tableBehaviours.onTableCtrlI);
    router.register(tableBehaviours.onTableDeleteContent);
    router.register(tableBehaviours.onTableBackspace);
    router.register(tableBehaviours.onSelectedTableKeyPressShift);
    router.register(tableBehaviours.onSelectedTableKeyPress);
    router.register(tableBehaviours.onTabLastTableCell);
    router.register(tableBehaviours.onReselection);
    router.register(tableBehaviours.onBackspaceAtStartOfTableCell);
    router.register(tableBehaviours.onDeleteAtEndOfTableCell);
    router.register(tableBehaviours.onTableEnter);
};
exports.registerTableBehaviours = registerTableBehaviours;
var registerTableNavigationBehaviours = function (di, router) {
    var tableNavigationBehaviours = di.invoke(TableNavigationBehaviours_1.default);
    router.register(tableNavigationBehaviours.onTableMoveDown);
    router.register(tableNavigationBehaviours.onTableMoveUp);
    router.register(tableNavigationBehaviours.onTableTab);
    router.register(tableNavigationBehaviours.onTableShiftTab);
    router.register(tableNavigationBehaviours.onShiftNavigationGoingUp);
    router.register(tableNavigationBehaviours.onShiftNavigationGoingDown);
    router.register(tableNavigationBehaviours.onShiftNavigationGoingRight);
    router.register(tableNavigationBehaviours.onShiftNavigationGoingLeft);
};
exports.registerTableNavigationBehaviours = registerTableNavigationBehaviours;
var registerContentLoopBehaviours = function (di, router) {
    var contentLoopBehaviours = di.invoke(ContentLoop_1.getContentLoopBehaviours);
    router.register(contentLoopBehaviours.onSetContentLoopVariable);
    router.register(contentLoopBehaviours.onRemoveContentLoopVariable);
    router.register(contentLoopBehaviours.onDropContentLoopVariable);
    router.register(contentLoopBehaviours.onBackspaceAtContentLoopStart);
    router.register(contentLoopBehaviours.onDeleteAtContentLoopEnd);
};
exports.registerContentLoopBehaviours = registerContentLoopBehaviours;
var registerVariableBehaviours = function (di, router) {
    var variableBehaviours = di.invoke(VariableBehaviours_1.default);
    router.register(variableBehaviours.onBackspaceAfterVariable);
    router.register(variableBehaviours.onDeleteBeforeVariable);
    router.register(variableBehaviours.onDragOverVariable);
    router.register(variableBehaviours.onDropVariable);
    router.register(variableBehaviours.onDeleteVariableWithToolbar);
    router.register(variableBehaviours.onBoldVariableWithToolbar);
    router.register(variableBehaviours.onItalicVariableWithToolbar);
    router.register(variableBehaviours.onStrikethroughVariableWithToolbar);
    router.register(variableBehaviours.onAddTokenWidget);
    router.register(variableBehaviours.onCancelTokenWidget);
    router.register(variableBehaviours.onInsertVariable);
};
exports.registerVariableBehaviours = registerVariableBehaviours;
var registerCommentBehaviours = function (di, router) {
    var commentBehaviours = di.invoke(CommentBehaviours_1.default);
    router.register(commentBehaviours.moveRightFromComment);
    router.register(commentBehaviours.onAppendToComment);
    router.register(commentBehaviours.onCommentMarkerDelete);
    router.register(commentBehaviours.onCommentUpdate);
};
exports.registerCommentBehaviours = registerCommentBehaviours;
var registerSideBySideBehaviours = function (di, router) {
    var sideBySideBehaviours = di.invoke(SideBySideBehaviours_1.getSideBySideBehaviours);
    router.register(sideBySideBehaviours.onChangeSideBySidePercentage);
    router.register(sideBySideBehaviours.onDismissSideBySidePlaceholder);
    router.register(sideBySideBehaviours.onUploadImage);
    router.register(sideBySideBehaviours.onEmbedImage);
    router.register(sideBySideBehaviours.onSwapOrderForSideBySide);
    router.register(sideBySideBehaviours.onBackspaceAtColumnStart);
    router.register(sideBySideBehaviours.onDeleteAtColumnEnd);
};
exports.registerSideBySideBehaviours = registerSideBySideBehaviours;
var registerButtonBehaviours = function (di, router) {
    var buttonBehaviours = di.invoke(ButtonBehaviours_1.default);
    router.register(buttonBehaviours.onUpdateButton);
    router.register(buttonBehaviours.onManualButtonSelect);
    router.register(buttonBehaviours.onEnterInLabel);
    router.register(buttonBehaviours.onArrowDownInLabel);
    router.register(buttonBehaviours.onArrowUpInLabel);
};
exports.registerButtonBehaviours = registerButtonBehaviours;
var registerROICalculatorBehaviours = function (di, router) {
    var roiCalcBehaviours = di.invoke(ROICalculatorBehaviours_1.default);
    router.register(roiCalcBehaviours.onSelectROICalculatorPreset);
    router.register(roiCalcBehaviours.onUpdateROICalculatorVariableInputs);
    router.register(roiCalcBehaviours.onUpdateROICalculatorOptions);
    router.register(roiCalcBehaviours.onUpdateROICalculatorRichText);
    router.register(roiCalcBehaviours.onAddROICalculatorVariableInput);
    router.register(roiCalcBehaviours.onRemoveROICalculatorVariableInput);
    router.register(roiCalcBehaviours.onPickROICalculatorImage);
    router.register(roiCalcBehaviours.onAddROICalculatorImage);
    router.register(roiCalcBehaviours.onUploadROICalculatorImage);
    router.register(roiCalcBehaviours.onRemoveROICalculatorImage);
    router.register(roiCalcBehaviours.trackEditROICalculatorOption);
    router.register(roiCalcBehaviours.trackROICalculatorSliderInteraction);
    router.register(roiCalcBehaviours.trackROICalculatorVariableInputInteraction);
    router.register(roiCalcBehaviours.trackROITourModalClosed);
};
exports.registerROICalculatorBehaviours = registerROICalculatorBehaviours;
var registerAccordionBehaviours = function (di, router) {
    var accordionBehaviours = di.invoke(AccordionBehaviours_1.getAccordionBehaviours);
    if (di.get("usingFeature")(FeatureFlag_1.default.Accordion)) {
        router.register(accordionBehaviours.onSelectAccordion);
        router.register(accordionBehaviours.onSetAccordionExpanded);
        router.register(accordionBehaviours.onCloneAccordion);
        router.register(accordionBehaviours.onEnterAtEndOfAccordionHeading);
        router.register(accordionBehaviours.onQuickCreateAccordion);
        router.register(accordionBehaviours.onSwapAccordionImage);
        router.register(accordionBehaviours.onEnsureVisualAccordionImages);
        router.register(accordionBehaviours.onBackspaceAtStartOfAccordionHeading);
        router.register(accordionBehaviours.onBackspaceAfterCollapsedAccordion);
        router.register(accordionBehaviours.onTabInsideAccordionHeading);
        router.register(accordionBehaviours.onTabInsideAccordionBody);
        router.register(accordionBehaviours.onShiftTabInsideAccordionHeading);
        router.register(accordionBehaviours.onShiftTabInsideAccordionBody);
    }
};
exports.registerAccordionBehaviours = registerAccordionBehaviours;
var registerWidgetRegistryBehaviours = function (di, router) {
    var e_1, _a;
    var behaviours = di.invoke(WidgetRegistryBehaviours_1.default);
    try {
        for (var behaviours_1 = __values(behaviours), behaviours_1_1 = behaviours_1.next(); !behaviours_1_1.done; behaviours_1_1 = behaviours_1.next()) {
            var behaviour = behaviours_1_1.value;
            router.register(behaviour);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (behaviours_1_1 && !behaviours_1_1.done && (_a = behaviours_1.return)) _a.call(behaviours_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
exports.registerWidgetRegistryBehaviours = registerWidgetRegistryBehaviours;
var registerSyntheticSelectionBehaviours = function (di, router) {
    var e_2, _a;
    var behaviours = di.invoke(SyntheticSelectionBehaviours_1.default);
    try {
        for (var behaviours_2 = __values(behaviours), behaviours_2_1 = behaviours_2.next(); !behaviours_2_1.done; behaviours_2_1 = behaviours_2.next()) {
            var behaviour = behaviours_2_1.value;
            router.register(behaviour);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (behaviours_2_1 && !behaviours_2_1.done && (_a = behaviours_2.return)) _a.call(behaviours_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
exports.registerSyntheticSelectionBehaviours = registerSyntheticSelectionBehaviours;
